export default __webpack_public_path__ + "media/images/paypal-386ff11a930a72fac5893322f8c19f80.svg";